import { ColorModel, MaterialModel } from '@common/models';
import SlabIcon from '@core/components/slab-icon/slab-icon';
import ImageUtils from '@core/utils/ImageUtils';

import './selectedMaterialColor.scss';

export interface SelectedMaterialColorProps {
    selectedMaterial?: MaterialModel;
    selectedColor?: ColorModel;
}

export const SelectedMaterialColor = ({ selectedColor, selectedMaterial }: SelectedMaterialColorProps): JSX.Element => {
    return (
        <div className="selection-title-area">
            {selectedColor && selectedMaterial && (
                <div className="text-area">
                    <SlabIcon src={ImageUtils.imgUrl(selectedColor.swatchImageUrl)} />
                    <div>
                        <div className="material-name">{selectedMaterial.description}</div>
                        <div>{selectedColor.name}</div>
                    </div>
                </div>
            )}
        </div>
    );
};
